import { render, staticRenderFns } from "./CommonPropertyCard.vue?vue&type=template&id=f7945108&scoped=true&"
import script from "./CommonPropertyCard.vue?vue&type=script&lang=js&"
export * from "./CommonPropertyCard.vue?vue&type=script&lang=js&"
import style0 from "./CommonPropertyCard.vue?vue&type=style&index=0&id=f7945108&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7945108",
  null
  
)

export default component.exports